<template>
<!-- 语言选择器 -->
  <div class="language-selector" ref="languageSelectorRef">
    <div class="selected-language" @click="toggleDropdown">
      <img src="@/assets/translation.png" alt="Language" class="language-icon">
      <span>{{ currentLanguage === 'en' ? 'English' : '简体中文' }}</span>
      <img 
        :src="isOpen ? topIcon : bottomIcon" 
        alt="arrow" 
        class="arrow-icon">
    </div>
    <div class="language-dropdown" v-show="isOpen">
      <div 
        class="language-option" 
        :class="{ 'selected': currentLanguage === 'en' }"
        @click="selectLanguage('en')"
      >English</div>
      <div 
        class="language-option" 
        :class="{ 'selected': currentLanguage === 'zh' }"
        @click="selectLanguage('zh')"
      >简体中文</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import bottomIcon from '@/assets/icon/bottom.png'
import topIcon from '@/assets/icon/top.png'

const currentLanguage = ref(localStorage.getItem('language') || 'en')
const isOpen = ref(false)
const languageSelectorRef = ref(null)

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const selectLanguage = (lang) => {
  currentLanguage.value = lang
  localStorage.setItem('language', lang)
  // 刷新页面以应用新的语言
  window.location.reload()
  isOpen.value = false
}

// 处理点击外部区域
const handleClickOutside = (event) => {
  if (languageSelectorRef.value && !languageSelectorRef.value.contains(event.target)) {
    isOpen.value = false
  }
}

// 组件挂载时添加事件监听
onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

// 组件卸载时移除事件监听
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
.language-selector {
  position: relative;
  display: inline-block;
  border: 1px solid rgba(0,0,0,0.1);
  padding-left: 5px;
  padding-right: 5px;
}

.selected-language {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: white;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
}

/* 在移动端隐藏文字和箭头 */
@media screen and (max-width: 768px) {
  .selected-language span,
  .arrow-icon {
    display: none;
  }

  .selected-language {
    padding: 8px;
    width: auto;
    height: auto;
    border: none;
  }

  .language-icon {
    width: 20px;
    height: 20px;
  }

  /* 调整下拉菜单位置 */
  .language-dropdown {
    right: 0;
    left: auto;
    min-width: 120px;
  }
}

.language-icon {
  width: 16px;
  height: 16px;
}

.selected-language span:nth-child(2) {
  flex: 1;
  text-align: center;
  margin-right: 16px;
}

.arrow-icon {
  position: absolute;
  right: 12px;
  width: 10px;
  height: 9.6px;
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 0px;
  margin-top: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 120px;
}

.language-option {
  padding: 10px 12px;
  cursor: pointer;
  margin-left: 10px;
}

.language-option:active {
  color: #007AFF;
}

.language-option.selected {
  color: #007AFF;
}

/* 在移动端时的特殊处理 */
@media screen and (max-width: 768px) {
  .language-dropdown {
    right: 0;
    min-width: 100px;
    transform-origin: top right;
  }

  .language-option {
    padding: 8px 12px;
    white-space: nowrap;
  }
}
</style> 